module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading3dAssets":"Loading 3D assets, please don\u0027t close the page"},"ro":{"loading3dAssets":"Se încarcă modelele 3D, nu închideți pagina"}}')
  delete Component.options._Ctor
}
